import React from 'react';
import PropTypes from 'prop-types';
import Formatters from '../../shared/utils/Formatters';

const RCLOfferNotification  = ({amount=null}) => {
  return (      
    <div className='ds-card'>
      <section className='cardSection _textAlign_center -warning'  data-testid='rcl-offer-notification-card'>
        <h2 className='headline -darkBlue' data-testid='rcl-offer-notification-title'>
          This loan is under review:
        </h2>
        <h2 data-testid='rcl-offer-notification-amount' className='headline -primary'>
          ₱ {Formatters.currencyDecimal(amount)}
        </h2>
        <p className='byline -secondary --small' data-testid='rcl-offer-notification-copy'>
          We will notify you once the request has been approved.
        </p>
      </section>
    </div>
  );
}

RCLOfferNotification.propTypes = {
  amount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
}

export default RCLOfferNotification;



// WEBPACK FOOTER //
// ./src/features/home/components/RCLOfferNotification.js